<template>
  <el-container class="outer-container"
                v-if="showCpn">
    <el-header class="outheader">
      <TopHeader>
      </TopHeader>
    </el-header>
    <el-container class="inner-container">
      <el-aside class="inner-aside">
        <asideMenue></asideMenue>
      </el-aside>
      <el-container class="inner-container2">
        <HeadProduct v-if="!$store.state.user.loginInfo.is_partner"></HeadProduct>
        <div v-if="isShowTip"
             class="headMsgBox"
             v-html="msg"></div>
        <div v-if="isShowVisitCount"
             class="headMsgBox"
             v-html="visitCountMsg"></div>
        <el-main>
          <el-scrollbar style="height:100%;scroll-behavior:smooth;"
                        ref="scrollbar">
            <div style="width:100%">
              <el-header class="header">
                <MainHeader v-if="showMainHeader">
                </MainHeader>
              </el-header>
              <router-view class="roterView"
                           v-if="showView" />
              <Footer v-if="!$store.state.user.loginInfo.is_partner">
              </Footer>
            </div>
          </el-scrollbar>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import asideMenue from '@/components/AsideMenue.vue'
import TopHeader from '@/components/topHeader.vue'
import MainHeader from '@/components/mainHeader.vue'
import HeadProduct from '@/components/headProduct.vue'
import Footer from '@/components/footer.vue'
import { getServerStatus, getMmiVisitCount } from '@/api/user'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { getDefaultDate } from '@/api/baseInfo'
export default {
  components: { asideMenue, TopHeader, Footer, MainHeader, HeadProduct },
  data() {
    return {
      isShowTip: false,
      msg: '',
      isShowVisitCount: false,
      visitCountMsg: '',
      showCpn: false,
      showView: true,
      hasScrolledToTopOnce: false,
    }
  },
  async created() {
    const browserFinger = this.$store.state.user.browserFinger
    if (!browserFinger) {
      this.showCpn = false
      const fpPromise = FingerprintJS.load()
      const fp = await fpPromise
      const result = await fp.get()
      localStorage.setItem('browserFinger', result.visitorId)
      this.$store.dispatch('user/changeBrowserFinger', result.visitorId)
      this.showCpn = true
    } else {
      this.showCpn = true
    }
    this.getDefaultDateFun()
    this.getServer()
    this.getVisitCountData()
  },
  mounted() {
    this.$eventBus.$on('TopScroll', () => {
      if (this.$refs.scrollbar) {
        this.$refs.scrollbar.wrap.scrollTop = 0
      }
    })
    this.$eventBus.$on('routerViewScroll', (val) => {
      if (this.$refs.scrollbar) {
        // this.$refs.scrollbar.wrap.scrollTop = val
        this.$refs.scrollbar.wrap.scrollTo({
          top: val,
          behavior: 'smooth', // 启用平滑滚动
        })
      }
    })
    this.$eventBus.$on('refreshView', this.refreshView)
    // this.$refs.scrollbar.wrap.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    getDefaultDateFun() {
      let params = {}
      params.plat = this.$store.state.user.plants
        ? this.$store.state.user.plants.join(',')
        : ''

      getDefaultDate(params).then((res) => {
        const startMonth = this.$store.state.user.startMonth
        const endMonth = this.$store.state.user.endMonth
        if (res.status == 'ok') {
          if (!startMonth) {
            this.$store.dispatch('user/changeStartMonth', res.result.end)
          }
          if (!endMonth) {
            this.$store.dispatch('user/changeEndMonth', res.result.end)
          }
          localStorage.setItem('defaultStartMonth', res.result.start)
          localStorage.setItem('defaultEndMonth', res.result.end)
        }
      })
    },
    refreshView() {
      this.showView = false
      this.$nextTick(() => {
        this.showView = true
      })
    },
    getServer() {
      getServerStatus()
        .then((res) => {
          if (res.status == 'ok') {
            let msgArr = res.result
            if (Object.prototype.toString.call(msgArr) === '[object Array]') {
              let str = ''
              for (let i = 0; i < msgArr.length; i++) {
                if (msgArr[i].status == 1 || msgArr[i].status == 2) {
                  str +=
                    '<div style="color:inherit">' + msgArr[i].msg + '</div>'
                }
              }
              if (str != '') {
                this.msg = str
                this.isShowTip = true
              }
            }
            // if (res.result.status == 1 || res.result.status == 2) {
            //   this.msg = res.result.msg
            //   this.isShowTip = true
            // }
          } else {
            this.$message.error('请求失败')
          }
        })
        .catch((e) => {
          this.isShowTip = false
          // this.$message.success('请求失败')
        })
    },
    getVisitCountData() {
      getMmiVisitCount()
        .then((res) => {
          if (res.status == 'ok') {
            console.log(res)
            if (res.result.data) {
              this.visitCountMsg = res.result.data
              this.isShowVisitCount = true
            }
          } else {
            this.$message.error('请求失败')
          }
        })
        .catch((e) => {
          this.isShowVisitCount = false
          // this.$message.success('请求失败')
        })
    },
    handleScroll() {
      const top = this.$refs.scrollbar.wrap.scrollTop
      if (top > 1) {
        this.$eventBus.$emit('showNavCrumb', true)
        this.hasScrolledToTopOnce = false
      } else {
        if (top == 0) {
          if (this.hasScrolledToTopOnce) {
            this.$eventBus.$emit('showNavCrumb', false)
          } else {
            this.$refs.scrollbar.wrap.scrollTop = 1
            setTimeout(() => {
              this.hasScrolledToTopOnce = true
            }, 700)
          }
        }
      }
    },
  },
  computed: {
    showMainHeader() {
      return this.$store.state.user.SHowMainHead
    },
    showTopHeader() {
      return this.$store.state.user.SHowTopHead
    },
    key() {
      return this.$route.name
        ? this.$route.name + this.$route.query.toString() + new Date().getTime()
        : this.$route + new Date().getTime()
    },
  },
  watch: {
    '$store.state.user.ActivedTab': {
      handler(newVal, oldVal) {
        this.getVisitCountData()
      },
      immidiate: true,
    },
  },
}
</script>

<style scoped lang="less">
.headMsgBox {
  font-size: 14px;
  padding: 15px;
  background-color: #fcf8e3;
  border-color: #faebcc;
  color: #8a6d3b;
  width: 100%;
}
</style>
